import React, { Fragment } from "react";
import { ApiResult } from "../../lib/CmsApi";
import MagazinHeader from "./MagazinHeader";
import Content from "../common/Content";
import FundingStory from "./MagazineTeaser/FundingStory";
import Button from "../common/Button";
import HeaderWithIntro from "../common/HeaderWithIntro";
import Section from "../sections/Section";
import EventSliderSection from "../sections/EventSlider";

import { spacing } from "../theme";
import styled from "styled-components";
import CheckerboardComponent from "../common/CheckerboardComponent";
import ArticleTeaser from "./MagazineTeaser/ArticleTeaser";
import CustomPageHead from "../common/CustomPageHead";
import EmptyList from "./EmptyList";
import Seo from "../../lib/models/seo";

const StyledButton = styled(Button)`
  ${spacing("margin-top", 64)}
`;
export interface Props {
  tags: ApiResult<"listTags">;
  activeTags: string[];

  newsPage: ApiResult<"loadMagazinNewsPage">;
  news: ApiResult<"listMagazinNews">;

  portraitPage: ApiResult<"loadMagazinPortraitPage">;
  portraits: ApiResult<"listMagazinPortraits">;

  eventPage: ApiResult<"loadMagazinEventPage">;
  events: ApiResult<"listExternalEvents">;
  seo?: Seo;
}
export default function MagazinPage(props: Props) {
  let offset = 0;
  const now = new Date();
  return (
    <Fragment>
      <CustomPageHead title="Magazin" seo={props.seo} />
      <MagazinHeader tags={props.tags} activeTags={props.activeTags} />
      <main>
        {props.news.total > 0 && (
          <Section noTopPadding>
            <Content padded>
              <HeaderWithIntro
                headline={props.newsPage.name}
                intro={props.newsPage.intro}
                size={1}
                blue
              />
              <CheckerboardComponent>
                {props.news.items.map((item, idx) => {
                  if (!item.headerImage) offset++;
                  return (
                    <ArticleTeaser
                      {...item}
                      key={item.slug}
                      swap={(idx + offset) % 2 !== 0}
                    />
                  );
                })}
              </CheckerboardComponent>
              <StyledButton
                route={"news"}
                params={{ tags: props.activeTags.join(",") }}
                alignCenter
              >
                Mehr News ansehen
              </StyledButton>
            </Content>
          </Section>
        )}
        {props.events.total > 0 && (
          <EventSliderSection
            sectionProps={{ noTopPadding: true }}
            events={props.events.items}
            params={{ tags: props.activeTags.join(",") }}
            headline={props.eventPage.name}
            copy={props.eventPage.intro}
            maxItems={5}
          />
        )}
        {props.portraits.total > 0 && (
          <Section noTopPadding>
            <Content padded>
              <HeaderWithIntro
                headline={props.portraitPage.name}
                intro={props.portraitPage.intro}
                size={1}
                blue
              />
              {props.portraits.items.map(item => {
                return (
                  <FundingStory
                    key={item.slug}
                    headerImage={item.headerImage}
                    slug={item.slug}
                    title={item.title}
                    programs={item.programs as any}
                    categories={item.categories}
                  />
                ); //TODO: Fix any
              })}
              <Button
                route={"portraits"}
                params={{ tags: props.activeTags.join(",") }}
                alignCenter
              >
                Mehr Förderportraits ansehen
              </Button>
            </Content>
          </Section>
        )}
        {props.news.total < 1 &&
          props.events.total < 1 &&
          props.portraits.total < 1 && (
            <Content smallBottomMargin padded>
              <EmptyList />
            </Content>
          )}
      </main>
    </Fragment>
  );
}

MagazinPage.getImages = (props: Props) => {
  let images = [];
  images = images.concat(
    props.news.items.map(n => n.headerImage).filter(Boolean)
  );
  props.portraits.items.forEach(p => {
    images = images.concat(FundingStory.getImages(p));
  });
  return images;
};
